import * as actionsTypes from './actionsTypes';
import * as API from '../../API/API';

export const infSearch = (type, query, page) => ({
  type: actionsTypes.INF_SEARCH,
  payload: API.inf_search(type, query, page),
});

export const searchQueryChanged = query => ({
  type: actionsTypes.SEARCH_QUERY_CHANGED,
  query,
});

export const selectValueChanged = (value) => ({
  type: actionsTypes.SELECT_VALUE_CHANGED,
  value,
});